import { cn } from "@/libs/utils";

import CommonRadio, { RadioItem } from "@/components/Common/Radio";

type Props = {
  wrapperClassName?: string;
  name: string;
  radioList: RadioItem[];
  defaultValue: string;
  onChange: (value: string) => void;
};
export default function FilterRadioItem({
  wrapperClassName = "",
  name,
  radioList,
  defaultValue,
  onChange,
}: Props) {
  return (
    <div className={cn("grid grid-cols-4 gap-y-3", wrapperClassName)}>
      {radioList.map((radio, index) => (
        <CommonRadio
          key={index}
          label={radio.label}
          name={name}
          defaultValue={radio.value}
          checked={defaultValue.toString() === radio.value}
          onChange={(value) => {
            onChange(value);
          }}
        />
      ))}
    </div>
  );
}
